import { AnyAction, combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from 'redux-persist/lib/storage';
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
  } from "redux-persist";
import type { Middleware } from "@reduxjs/toolkit"

import { authApi } from '../Apis/authApi'
import { panelApi } from '../Apis/panelApi'
import { blogApi } from '../Apis/blogApi'
import { mediaApi } from '../Apis/mediaApi'
import { utilApi } from '../Apis/utilApi'
import { contactInfoApi } from "../Apis/contactInfoApi";
import { messageApi } from '../Apis/messageApi'
import { invoiceApi } from '../Apis/invoiceApi'
import authReducer from '../Slices/authSlice'
import sectionReducer from '../Slices/sectionSlice'
import { shopApi } from "../Apis/shopApi";
import { productApi } from "../Apis/productApi";
import { shippingApi } from "../Apis/shippingApi";
import { paymentApi } from "../Apis/paymentApi";
import { ebroApi } from "../Apis/ebroApi";

const persistConfig = {
    key: 'root',
    version: 1,
    storage,
    blacklist: [
        authApi.reducerPath,
        panelApi.reducerPath,
        blogApi.reducerPath,
        mediaApi.reducerPath,
        utilApi.reducerPath,
        contactInfoApi.reducerPath,
        messageApi.reducerPath,
        invoiceApi.reducerPath,
        shopApi.reducerPath,
        productApi.reducerPath,
        shippingApi.reducerPath,
        paymentApi.reducerPath,
        ebroApi.reducerPath,
    ],
}

const appReducer = combineReducers({
    auth: authReducer,
    section: sectionReducer,
    [authApi.reducerPath]: authApi.reducer,
    [panelApi.reducerPath]: panelApi.reducer,
    [blogApi.reducerPath]: blogApi.reducer,
    [mediaApi.reducerPath]: mediaApi.reducer,
    [utilApi.reducerPath]: utilApi.reducer,
    [contactInfoApi.reducerPath]: contactInfoApi.reducer,
    [messageApi.reducerPath]: messageApi.reducer,
    [invoiceApi.reducerPath]: invoiceApi.reducer,
    [shopApi.reducerPath]: shopApi.reducer,
    [productApi.reducerPath]: productApi.reducer,
    [shippingApi.reducerPath]: shippingApi.reducer,
    [paymentApi.reducerPath]: paymentApi.reducer,
    [ebroApi.reducerPath]: ebroApi.reducer,
})


const reducerProxy = (state: ReturnType<typeof appReducer> | undefined, action: AnyAction) => {
    if(action.type === 'USER_LOGOUT') {
        storage.removeItem('persist:root');
        return appReducer(undefined, action);
    }
    return appReducer(state, action);
}

const persistedReducer = persistReducer(persistConfig, reducerProxy)

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]},
        }).concat([
            authApi.middleware,
            panelApi.middleware,
            blogApi.middleware,
            mediaApi.middleware,
            utilApi.middleware,
            contactInfoApi.middleware,
            messageApi.middleware,
            invoiceApi.middleware,
            shopApi.middleware,
            productApi.middleware,
            shippingApi.middleware,
            paymentApi.middleware,
            ebroApi.middleware,
        ] as Middleware[]),
    devTools: false,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const persistor = persistStore(store)